import { TitleComponent } from '@/widgets/page-header';
import { CustomTabs } from '@/shared/ui/components';
import { auth } from '@/shared/lib';
import classNames from 'classnames';
import { t } from 'ttag';
import DevicesMaintenanceTable from './devicesMaintenanceTable/devicesMaintenanceTable';
import { useRma } from './useRma';
import './rma.scss';
import RmaRequestTable from './rmaRequestTable/rmaRequestTable';
import WaitingToReturnTab from './waitingToReturnTab/waitingToReturnTab';

/**
 * Renders the Fleet page hosting the Waiting for Return, RMA Request and Maintenance tabs. Pulls page state, the header ref, facility selection, RMA ticket count and tab navigation from useRma, renders nothing while isReloading is true, and adds a marketing-banner offset class when a marketing or logo banner is active.
 *
 * @returns The Fleet page tree, or false while the page is reloading.
 */
const RmaPage = () => {
  const {
    state,
    headerRef,
    supportFacilities,
    selectedFacilityRedux,
    rmaTicketCountRedux,
    isHideWaitingForReturnTab,
    isFacilitySubscribeProtectPlus,
    isReloading,
    navigateTab,
  } = useRma();

  /**
   * Builds the tab descriptors of the Fleet page. Always includes the RMA Request tab with its ticket-count badge and the Maintenance tab, and prepends the Waiting for Return tab unless it is hidden; each tab renders its table with the active-tab flag plus the selected and supported facilities.
   *
   * @returns Ordered tab items for the CustomTabs component.
   */
  const listTabRma = () => {
    const listTab = [
      {
        key: '2',
        label: <div>{t`RMA Request`}</div>,
        quantity: rmaTicketCountRedux,
        quantityClassName: 'rma-ticket-count',
        children: (
          <RmaRequestTable
            isActive={state.activeTab === '2'}
            selectedFacility={selectedFacilityRedux}
            supportFacilities={supportFacilities ?? []}
          />
        ),
      },
      {
        key: '3',
        label: <div>{t`Maintenance`}</div>,
        children: (
          <DevicesMaintenanceTable
            isFacilitySubscribeProtectPlus={isFacilitySubscribeProtectPlus}
            isActive={state.activeTab === '3'}
            selectedFacility={selectedFacilityRedux}
            supportFacilities={supportFacilities ?? []}
          />
        ),
      },
    ];

    if (!isHideWaitingForReturnTab) {
      listTab.unshift({
        key: '1',
        label: <div>{t`Waiting for Return`}</div>,
        children: <WaitingToReturnTab />,
      });
    }

    return listTab;
  };

  return (
    !isReloading && (
      <div
        ref={headerRef}
        className={classNames('rma-request-page animated fadeIn', {
          'has-marketing-banner': auth.hasMarketingBanner() || auth.hasLogoBanner(),
        })}
      >
        <div className="top-container">
          <TitleComponent
            title={t`Fleet`}
            isShowListFacility
            isShowTypeSeeStudies={state.activeTab === '1'}
          />
        </div>
        <div className="rma-request-tab">
          <CustomTabs
            activeKey={state.activeTab}
            onChange={navigateTab}
            items={listTabRma() as any}
          />
        </div>
      </div>
    )
  );
};

export default RmaPage;
